<template>
  <div
    class="sliderImage__container"
    :class="[
      type !== 'profilo' ? 'imgPrj' : '',
      type === 'filler' ? 'filler' : '',
    ]"
    alt=""
  >
    <router-link v-if="type !== 'profilo'" :to="'prj/' + page">
      <!-- <div
    class="sliderImage__container"
    :class="type !== 'profilo' && numSlid === Nprj - 1 ? 'imgPrj' : ''"
    alt=""
  > -->
      <img v-if="type !== 'filler'" :src="url" />
    </router-link>
    <!-- <img  v-else-if="type !== 'filler'" :src="url" /> -->
    <MglMap v-else
     :interactive="false"
      :accessToken="accessToken"
      :mapStyle="mapStyle"
    >
      <MglMarker :coordinates="coord" color="black"></MglMarker
    ></MglMap>
  </div>
</template>

<script>
import Mapbox from "mapbox-gl";
import { MglMap, MglMarker } from "vue-mapbox";
export default {
  components: {
    MglMap,
    MglMarker,
  },
  props: {
    type: String,
    url: String,
    page: String,
    numSlid: Number,
    val: Number,
  },
  data() {
    return {
      map: {},
      coord: [9.227,45.533],
      accessToken:
        "pk.eyJ1IjoidGVtcDA4IiwiYSI6ImNrMng4OWJyNjBmNDYzZ280ZnpsYWUyN3YifQ.rBtvUyD_V16SKpNTdhjElg", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/temp08/cl2hqm3qw005p14mrn3k5ifuu", // your map style
    };
  },
  computed: {
    Nprj() {
      console.log("VAL: " + this.val);
      console.log("PRJ: " + this.$store.state.homePrj);
      // this.pushHover()
      return this.$store.state.homePrj;
    },
  },
  methods: {
    pushHover() {
      setTimeout(() => {
        var img = document.getElementById(this.val);
        img.classList.add("hov");
      }, 300);
    },
  },
  mounted() {
    let root = document.documentElement;
    // var fillWid = document.querySelector(".imga").clientWidth;
    var fillWid = document.querySelector(".checker").clientWidth;
    root.style.setProperty("--filwid", fillWid + "px");
  },
  created() {
    this.map = Mapbox;
    // this.map = null;
  },
};
</script>

<style lang="scss" scoped>
:root {
  --filwid: 300px;
}
.sliderImage__container {
  height: 100%;
  // height: 400px;
  // width: 400px;
  scroll-snap-align: start;
  border-radius: 24px;
  margin-right: 16px;
  transition: 300ms ease-out;
  // transition-delay: 200ms;
  flex-shrink: 0;
  // border: 1px solid blue;
  aspect-ratio: 0.69;
  // width: 330px;
  height: 100%;
  //   aspect-ratio: 1.69;
  // width: 400px;
  overflow: hidden;
  // transform: rotate(90deg);
  //   transform-origin: right top;
  img {
    height: 100%;
    width: auto;
    object-fit: cover;
  }
}

.imgPrj {
  // cursor: pointer;
  // aspect-ratio: 1.4;
  &:hover{
    filter: blur(5px);
  }
  @media screen and (max-width: 767px) {
    // aspect-ratio: 1;
  }
}
.hov:hover {
  aspect-ratio: 1.4;
}

.filler {
  // background: coral;
  // opacity: 0;
  width: calc(67vw - var(--filwid) - 16px);
  @media screen and (max-width: 767px) {
    width: calc(100vw - var(--filwid) - 20px);
  }
}
</style>
